<template>
  <div class="grid gap-10 lg:grid-cols-2 lg:items-center" data-testid="builder-block">
    <div
      v-if="videoBuilderUrl"
      class="order-2 flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-paper-muted lg:order-1"
      aria-hidden="true"
    >
      <BaseIcon name="play" :size="28" class="text-accent-strong" />
    </div>
    <div class="order-1 flex flex-col gap-5 lg:order-2">
      <h2 class="text-3xl font-bold text-ink-strong md:text-4xl">{{ heading }}</h2>
      <p v-if="subheading" class="text-base text-ink-muted md:text-lg">{{ subheading }}</p>
      <ul v-if="promises.length > 0" class="flex flex-col gap-2 text-sm text-ink md:text-base">
        <li v-for="item in promises" :key="item" class="flex items-start gap-3">
          <BaseIcon name="check" :size="18" class="mt-0.5 shrink-0 text-accent" />
          <span>{{ item }}</span>
        </li>
      </ul>
      <div v-if="blocks.length > 0" class="flex flex-wrap gap-2">
        <span
          v-for="block in blocks"
          :key="block.id"
          class="inline-flex rounded-full border border-stroke bg-paper px-3 py-1 text-xs font-semibold text-ink"
        >
          {{ block.title }}
        </span>
      </div>
      <div>
        <BaseButton variant="primary" size="lg" @click="$emit('cta')">
          {{ ctaLabel }}
          <template #icon-right>
            <BaseIcon name="arrow-right" :size="20" />
          </template>
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseIcon from '@/components/base/BaseIcon.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import { ref } from 'vue';

interface Props {
  heading: string;
  subheading?: string;
  blocks: readonly { readonly id: string; readonly title: string }[];
  promises?: readonly string[];
  ctaLabel: string;
}

withDefaults(defineProps<Props>(), {
  subheading: '',
  promises: () => [],
});

defineEmits<{
  (e: 'cta'): void;
}>();

const videoBuilderUrl = ref(import.meta.env.VITE_VIDEO_BUILDER_URL);
</script>
